import React, { useContext, useState } from 'react';
import {
  required,
  email as emailValidation,
  BooleanInput,
  TextInput,
  FormWithRedirect,
  SaveButton,
  FormDataConsumer,
} from 'react-admin';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';

import { QuickAppointmentContext } from '../../Context';
import { apiGet } from '../../brainApi';
import SearchResult from './SearchResult';
import useStyles from '../styles';
import { getZ3PConfigValue } from '../../helper';

const NewContact = ({ editable }) => {
  const showFleetFields = getZ3PConfigValue('enable_fleet_in_admin_portal');
  const { handleNext, contactData, setContactData } = useContext(
    QuickAppointmentContext,
  );

  const classes = useStyles();

  const [emailValue, setEmailValue] = useState(null);
  const [customerResults, setCustomerResults] = useState([]);

  const handleSubmit = (values) => {
    setContactData((prev) => ({
      ...prev,
      ...values,
    }));
    handleNext();
  };

  const checkForExistingCustomer = (e) => {
    const { value } = e.target;
    setEmailValue(value);
    setCustomerResults([]);
    const filter = { q: value };
    const params = { filter: JSON.stringify(filter) };
    apiGet('/customer-search-detail', params).then((customers) => {
      if (customers && customers.length > 0) {
        const existingCustomer = customers.find(
          (c) => c.email?.toLowerCase() === value.toLowerCase(),
        );
        if (existingCustomer) setCustomerResults([existingCustomer]);
      }
    });
  };

  return (
    <div className={classes.main}>
      <FormWithRedirect
        resource="customer"
        record={contactData}
        save={handleSubmit}
        render={(formProps) => (
          <>
            <Grid container spacing={1} className={classes.formRoot}>
              <Grid item xs={12} sm={6} md={6}>
                <TextInput
                  source="first_name"
                  validate={[required()]}
                  disabled={!editable}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <TextInput
                  source="last_name"
                  label="Last name (optional)"
                  disabled={!editable}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <TextInput
                  source="email"
                  label="Email (optional)"
                  validate={emailValidation()}
                  onBlur={checkForExistingCustomer}
                  error={customerResults.length}
                  helperText={
                    customerResults.length
                      ? 'Customer account already exists. Select account below or change email address'
                      : null
                  }
                  disabled={!editable}
                  parse={(input) => input?.trim() || null}
                />
                {!!customerResults.length && (
                  <SearchResult
                    results={customerResults}
                    search_query={emailValue}
                    allowCreate={false}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <TextInput
                  source="phone"
                  label="Cell phone"
                  validate={[required()]}
                  disabled={!editable}
                />
              </Grid>
              {showFleetFields && (
                <Grid item xs={12} sm={6} md={6}>
                  <Grid
                    container
                    spacing={1}
                    className={classes.formRoot}
                    alignItems="center"
                  >
                    <Grid item xs={12} md={5}>
                      <BooleanInput
                        label="Is fleet user?"
                        source="is_fleet_user"
                        disabled={!editable}
                        initialValue={false}
                      />
                    </Grid>
                    <FormDataConsumer>
                      {({ formData }) => {
                        if (formData.is_fleet_user) {
                          return (
                            <Grid item xs={12} md={7}>
                              <TextInput
                                source="fleet_account_name"
                                disabled={!editable}
                              />
                            </Grid>
                          );
                        }
                        return null;
                      }}
                    </FormDataConsumer>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid container spacing={1}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
              >
                <DialogActions>
                  <SaveButton
                    label="Continue"
                    handleSubmitWithRedirect={(props) => {
                      formProps.handleSubmitWithRedirect(props);
                    }}
                    saving={formProps.saving}
                    className={classes.buttonWithoutIcon}
                    disabled={customerResults.length}
                  />
                </DialogActions>
              </Box>
            </Grid>
          </>
        )}
      />
    </div>
  );
};

export default NewContact;
